export default function SubmitCurpForm() {
    window.submitCurpForm = function () {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = document.querySelector('[data-curp-endpoint]')?.dataset?.curpEndpoint;
  
      const csrf = document.createElement('input');
      csrf.type = 'hidden';
      csrf.name = '_token';
      csrf.value = document.querySelector('meta[name="csrf-token"]').content;
      form.appendChild(csrf);
  
      const dataToSend = {};
  
      ['Name', 'FatherLastName', 'MotherLastName', 'Sex', 'BornDate', 'BornState'].forEach(id => {
        const input = document.getElementById(id);
        if (input) {
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = input.name ?? id;
          hidden.value = input.value;
          form.appendChild(hidden);
  
          dataToSend[hidden.name] = hidden.value;
        }
      });
  
      console.log("✅ Datos enviados a consultar.curp:", dataToSend);
  
      document.body.appendChild(form);
      form.submit();
    }
  }
  